// removed by extract-text-webpack-plugin
module.exports = {"ModalMessage":"ModalMessage__-loca-__2D7-J","FacebookIcon":"ModalMessage__-loca-__2mHXF","EtsyIcon":"ModalMessage__-loca-__1WDe1","FacebookText":"ModalMessage__-loca-__2pL8Z","EtsyText":"ModalMessage__-loca-__1eXtG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/TrdModalScreen/ModalMessage/ModalMessage.css
// module id = 137
// module chunks = 0